import React from 'react';
import { Link } from 'react-router-dom';
var HomePage = function () {
    return (React.createElement("div", { style: { padding: '20px', textAlign: 'center' } },
        React.createElement("header", null,
            React.createElement("h1", null, "Games"),
            React.createElement("nav", null,
                React.createElement("a", { href: "https://jbeat.com" }, "Home"),
                React.createElement("a", { href: "https://blog.jbeat.com" }, "Blog"),
                React.createElement("a", { href: "https://games.jbeat.com" }, "Games"))),
        React.createElement("div", null,
            React.createElement(Link, { to: "/starfall", style: {
                    display: 'block',
                    padding: '15px 30px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '5px',
                    minWidth: '200px'
                } }, "Starfall"),
            React.createElement(Link, { to: "/minesweeper", style: {
                    display: 'block',
                    padding: '15px 30px',
                    backgroundColor: '#2196F3',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '5px',
                    minWidth: '200px'
                } }, "Minesweeper"),
            React.createElement(Link, { to: "/snakes", style: {
                    display: 'block',
                    padding: '15px 30px',
                    backgroundColor: '#FF9800',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '5px',
                    minWidth: '200px'
                } }, "Snakes"),
            React.createElement(Link, { to: "/2026", style: {
                    display: 'block',
                    padding: '15px 30px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '5px',
                    minWidth: '200px'
                } }, "2026 Games"))));
};
export default HomePage;
